import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { UwContext } from '@ps20-frontend/uw';
import { isExtremwetterUWProcessNecessary } from '@ps20-frontend/selector';
import { VwgActions } from '../vwgActions';
import { IAppState } from '../appState';
import { mapStateToPremiumAndExtremwetterDisabledSelectorTo } from '../../app/shared/selectors/produkt.selector';

export function* watchConfirmUwApprovedOfferEdition() {
  yield takeEvery(
    GlobalActions.CONFIRM_UW_APPROVED_OFFER_EDITION,
    safeSaga(confirmUwApprovedOfferEdition, App.VWG),
  );
}

export function* confirmUwApprovedOfferEdition(action: {
  type: string;
  payload?: { appId: App; angebotsId: string };
}) {
  const globalPut = GlobalPut.getInstance();
  const { appId, angebotsId } = action.payload || { appId: null, angebotsId: null };

  const initialState: IAppState = yield select();

  if (appId !== App.VWG || angebotsId !== initialState.angebotsId) {
    return;
  }

  if (!initialState.vertragsoptionen.beibehalten) {
    const selectedProduktlinie = initialState.produkt.produktlinien.find(linie => linie.selected);
    const hasWeitereNaturgefahren = selectedProduktlinie?.zusatzoptionen.some(
      item => item.id === 'weitereNaturgefahren' && item.isSelected,
    );

    const isUnderwriterInfoVisible = Boolean(
      hasWeitereNaturgefahren &&
        isExtremwetterUWProcessNecessary(
          mapStateToPremiumAndExtremwetterDisabledSelectorTo(initialState),
        ),
    );

    yield call(
      globalPut.put,
      new GlobalActions().setNeedsUwResubmission(true, angebotsId, {
        [UwContext.NATURAL_HAZARDS]: isUnderwriterInfoVisible,
      }),
    );
  }

  yield put(new VwgActions().preiseRequested());

  yield take(GlobalActions.GESAMTPREIS_CHANGED);

  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    new GlobalActions().createStreckeSnapshot({ appId: App.VWG, angebotsId: state.angebotsId }),
  );

  yield call(globalPut.put, new GlobalActions().setEditingUwApprovedOffer(false));

  yield put(new VwgActions().absprungInsDashboard());
}
